import { API_BASE } from '../config/addresses';

// Saves PII to your PHP backend (which also sends the welcome email).
// On-chain we never store name/email/mobile — only this DB does.
export async function saveProfile({ wallet, userId, name, mobile, email, accountNumber, referrerId }) {
  const res = await fetch(`${API_BASE}/save-profile.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      wallet: (wallet || '').toLowerCase(),
      userId,
      name,
      mobile,
      email,
      accountNumber, // make sure save-profile.php stores this column
      referrerId,
    }),
  });
  const json = await res.json().catch(() => ({ success: false, message: 'Bad response' }));
  if (!res.ok || !json.success) throw new Error(json.message || 'Failed to save profile');
  return json;
}

export async function getProfile(wallet) {
  const res = await fetch(`${API_BASE}/get-profile.php?wallet=${encodeURIComponent((wallet || '').toLowerCase())}`);
  if (res.status === 404) return null;
  const json = await res.json().catch(() => null);
  if (!json || !json.success) return null;
  return json.data;
}

// Get this user's latest-distribution profit + income (raw 18-dec strings).
export async function getWeek(userId) {
  const res = await fetch(`${API_BASE}/get-week.php?userId=${encodeURIComponent(userId)}`);
  const json = await res.json().catch(() => null);
  if (!json || !json.success) return { round: 0, profit: '0', income: '0' };
  return { round: json.round, profit: json.profit, income: json.income };
}

// Get this user's level-income log (for Reports).
export async function getIncomeLog(userId, limit = 50) {
  const res = await fetch(`${API_BASE}/get-week.php?userId=${encodeURIComponent(userId)}&log=1&limit=${limit}`);
  const json = await res.json().catch(() => null);
  if (!json || !json.success) return [];
  return json.log || [];
}

// Admin: get the next distribution round number (call at start of distribution).
export async function nextRound() {
  const res = await fetch(`${API_BASE}/bump-round.php`, { method: 'POST' });
  const json = await res.json().catch(() => null);
  if (!json || !json.success) throw new Error('Failed to get distribution round');
  return json.round;
}

// Admin: save this distribution's profit + income + income log.
export async function saveWeekResults({ round, profits, incomes, log }) {
  const res = await fetch(`${API_BASE}/save-week-results.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ round, profits, incomes, log }),
  });
  const json = await res.json().catch(() => null);
  if (!json || !json.success) throw new Error('Failed to save results');
  return true;
}

// Batch lookup of names + account numbers by user IDs (Option B:
// the tree itself comes from chain; this only decorates with names).
export async function getNames(ids) {
  if (!ids || ids.length === 0) return {};
  const res = await fetch(`${API_BASE}/get-names.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ids }),
  });
  const json = await res.json().catch(() => null);
  if (!json || !json.success) return {};
  return json.data || {};
}
